var _Logo, _Skeleton;
import QuestionMarkCircle from '@crehana/compass.icons.outline/QuestionMarkCircle';
import { Skeleton } from '@crehana/compass.ui/v2';
import CrehanaIso from '@crehana/icons/logos/CrehanaIso';
import { neutralDark, neutralLight } from '@crehana/tailwindcss';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Tooltip } from '@crehana/ui';
import { clsx } from 'clsx';
import useCollaboratorTranslations from "../../../hooks/useMenuLinks/useCollaboratorTranslations";
import HelperTooltip from "../HelperTooltip";
import Logo from "../Logo";
import MenuLink from "../MenuLink";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var HelpItem = function HelpItem(_ref) {
  var sidebarType = _ref.sidebarType,
    onClickItem = _ref.onClickItem,
    organizationSlug = _ref.organizationSlug,
    children = _ref.children;
  if (sidebarType === 'admin' && onClickItem) {
    return /*#__PURE__*/_jsx("div", {
      role: "button",
      "aria-hidden": "true",
      onClick: function onClick() {
        return onClickItem("/org/".concat(organizationSlug, "/panel/guia-del-administrador/"));
      },
      children: children
    });
  }
  return /*#__PURE__*/_jsx("a", {
    href: "https://ayuda.crehana.com/",
    target: "_blank",
    rel: "noreferrer",
    children: children
  });
};
var Footer = function Footer(_ref2) {
  var footerLinks = _ref2.footerLinks,
    isDark = _ref2.isDark,
    organizationSlug = _ref2.organizationSlug,
    _onClickItem = _ref2.onClickItem,
    sidebarCollapsed = _ref2.sidebarCollapsed,
    isLoading = _ref2.isLoading,
    sidebarType = _ref2.sidebarType;
  var _useCollaboratorTrans = useCollaboratorTranslations(),
    t = _useCollaboratorTrans.t;
  var textColor = 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-600';
  var borderColor = 'tw-border-neutral-light-300 dark:tw-border-elevation-dark-03';
  var currentIconColor = isDark ? neutralDark[600] : neutralLight[700];
  var currentLogo = sidebarCollapsed ? /*#__PURE__*/_jsx(CrehanaIso, {
    size: 12,
    color: currentIconColor
  }) : _Logo || (_Logo = /*#__PURE__*/_jsx(Logo, {}));
  return /*#__PURE__*/_jsxs("footer", {
    className: clsx('tw-w-full tw-mt-auto tw-border-solid tw-border-t', borderColor, {
      'tw-flex tw-flex-col tw-items-center': sidebarCollapsed
    }),
    children: [/*#__PURE__*/_jsx("ul", {
      className: "tw-w-ful tw-pl-1.2 tw-pr-0.8",
      children: isLoading ? _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-full tw-h-4 tw-my-0.8 tw-rounded-0.8"
      })) : /*#__PURE__*/_jsx(_Fragment, {
        children: footerLinks === null || footerLinks === void 0 ? void 0 : footerLinks.map(function (link) {
          return /*#__PURE__*/_jsx(MenuLink, {
            menuLink: link,
            isDark: !!isDark,
            isFooterLink: true,
            sidebarCollapsed: sidebarCollapsed,
            onClickItem: function onClickItem() {
              // biome-ignore lint/style/useBlockStatements: single-line early return
              if (_onClickItem && link.url) _onClickItem(link.url);
            }
          }, link.code);
        })
      })
    }), /*#__PURE__*/_jsx(Tooltip, {
      label: /*#__PURE__*/_jsx(HelperTooltip, {
        title: t('SIDEBAR_HELP'),
        description: t('SIDEBAR_HELP_DESCRIPTION')
      }),
      position: "right",
      hidden: !sidebarCollapsed,
      isDark: !isDark,
      children: /*#__PURE__*/_jsx(HelpItem, {
        organizationSlug: organizationSlug,
        sidebarType: sidebarType,
        onClickItem: _onClickItem,
        children: /*#__PURE__*/_jsxs("div", {
          className: clsx('tw-flex tw-items-center tw-py-1.2 tw-px-2', {
            'tw-flex-col tw-items-center': sidebarCollapsed
          }),
          children: [/*#__PURE__*/_jsx(QuestionMarkCircle, {
            size: 16,
            className: textColor
          }), !sidebarCollapsed && /*#__PURE__*/_jsx("p", {
            className: clsx('tw-ml-0.8 tw-font-body5', textColor),
            children: t('SIDEBAR_HELP')
          })]
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: clsx("tw-flex tw-items-center tw-py-1.2 tw-px-2 tw-border-solid tw-border-t tw-w-full", borderColor, {
        'tw-flex-col tw-items-center': sidebarCollapsed
      }),
      children: currentLogo
    })]
  });
};
export default Footer;